<template>
  <div class=" is-fullwidth">
    <div >
      
      <div class="is-pulled-right mb-2" v-if="loading == false && orders.length > 0" style="display:none">
            
            <input class="input" v-model="search" placeholder="search orders ..."/>
            
        </div>
        <br style="clear:both" />
        <h3 class="title">Knitted Trims Report</h3>
      <div class="notification is-info" v-if="loading === true">Loading orders ...</div>
      <div class="notification is-warning" v-if="loading == false && filteredOrders.length == 0">There are no orders to show</div>

      <!--<div v-for="order in filteredOrders" :key="order.orderID">
        {{  order.ponumber }}<br />
      </div>-->
      
      <div v-if="loading == false && filteredOrders.length > 0">
        <h2 class="title is-4">Overview</h2>
                <div class="columns">
                    <div class="column">
                    <article class="message is-success">
                        <div class="message-header">
                        <p>Total</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.totalOrders }} orders<br />
                          {{ orderStats.totalQty }} garments
                        
                        </div>
                    </article>
                    </div>

                    <div class="column">
                    <article class="message is-link">
                        <div class="message-header">
                        <p>Offshore</p>
                        
                        </div>
                        <div class="message-body">
                          
                          {{ orderStats.location_offshore.count }} orders<br />
                            {{ orderStats.location_offshore.qty }} garments
                       
                        </div>
                    </article>
                    </div>
                    <div class="column">
                    <article class="message is-link">
                        <div class="message-header">
                        <p>Ireland</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.location_ireland.count }} orders<br />
                          {{ orderStats.location_ireland.qty }} garments
                       
                        </div>
                    </article>
                    </div>
                    <div class="column">
                    <article class="message is-link">
                        <div class="message-header">
                        <p>Not Specified Yet</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.location_not_set.count }} orders<br />
                          {{ orderStats.location_not_set.qty }} garments
                       
                       
                        </div>
                    </article>
                    </div>

                </div>

                <h2 class="title is-4">Trims Complete</h2>
                <div class="columns">
                    <div class="column">
                    <article class="message is-success">
                        <div class="message-header">
                        <p>Total</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.trim_complete.count }} orders<br />
                          {{ orderStats.trim_complete.qty }} garments
                        
                        </div>
                    </article>
                    </div>
                    <div class="column">
                    <article class="message is-link">
                        <div class="message-header">
                        <p>From Stock</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.from_stock.count }} orders<br />
                          {{ orderStats.from_stock.qty }} garments
                        
                        </div>
                    </article>
                    </div>
                    <div class="column">
                    <article class="message is-link">
                        <div class="message-header">
                        <p>Knit (See Next Row)</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.knit.count }} orders<br />
                          {{ orderStats.knit.qty }} garments
                        
                        </div>
                    </article>
                    </div>
                    
                  </div>

                  <h2 class="title is-4">Trims Knit (Not From Stock)</h2>
                  <div class="columns">
                      <div class="column">
                      <article class="message is-success">
                          <div class="message-header">
                          <p>Despatched</p>
                          
                          </div>
                          <div class="message-body">
                            {{ orderStats.despatched.count }} orders<br />
                            {{ orderStats.despatched.qty }} garments
                          
                          </div>
                      </article>
                      </div>
                      <div class="column">
                      <article class="message is-danger">
                          <div class="message-header">
                          <p>NOT Despatched</p>
                          
                          </div>
                          <div class="message-body">
                            {{ orderStats.not_despatched.count }} orders<br />
                            {{ orderStats.not_despatched.qty }} garments
                          
                          </div>
                      </article>
                      </div>
                    </div>

                  <h2 class="title is-4">Trims Outstanding</h2>
                <div class="columns">
                    <div class="column">
                    <article class="message is-danger">
                        <div class="message-header">
                        <p>Total</p>
                        
                        </div>
                        <div class="message-body">
                          {{ orderStats.trim_not_complete.count }} orders<br />
                          {{ orderStats.trim_not_complete.qty }} garments
                        
                        </div>
                    </article>
                    </div>
                  </div>
        </div>
      
    </div>

    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      
      accessToken: '',
      include_hidden: false,
      search: '',
      working:false,
      order_by : ''
      
    }
  },
   methods: {
    
    
      async getOrders() {
          this.loading=true
          this.orders = []
          OrderService.getKnittedTrimOrders(this.accessToken, this.order_by)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
        },
      
    
  },
  computed : {
    filteredOrders: function () {
       
        /*let filteredOrders =  this.orders.filter(function(u) {
            if(  u.active == 1) 
            {
              return 1
            }
            
          })*/

          let filteredOrders = this.orders

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.name.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     orderStats() {
        const stats = {
          totalOrders: 0,
          totalQty: 0,
          location_ireland: { count: 0, qty: 0 },
          location_offshore: { count: 0, qty: 0 },
          location_not_set: { count: 0, qty: 0 },
          trim_complete: { count: 0, qty: 0 },
          trim_not_complete: { count: 0, qty: 0 },
          from_stock: { count: 0, qty: 0 },
          knit: { count: 0, qty: 0 },
          despatched: { count: 0, qty: 0 },
          not_despatched: { count: 0, qty: 0 },
        };

        for (const order of this.filteredOrders) {
          const qty = order.total_qty || 0;
          stats.totalOrders += 1;
          stats.totalQty += qty;

          if (order.offshore === 1) {
            stats.location_offshore.count += 1;
            stats.location_offshore.qty += qty;
          }

          if (order.ireland === 1) {
            stats.location_ireland.count += 1;
            stats.location_ireland.qty += qty;
          }

          if (order.offshore === 0 && order.ireland === 0) {
            stats.location_not_set.count += 1;
            stats.location_not_set.qty += qty;
          }

          if (order.knit_complete === 1) {
            stats.trim_complete.count += 1;
            stats.trim_complete.qty += qty;

            if(order.knit_complete_type=="stock")
            {
              stats.from_stock.count += 1;
              stats.from_stock.qty += qty;
            } 
            else if(order.knit_complete_type=="knit")
            {
              stats.knit.count += 1;
              stats.knit.qty += qty;

              if(order.knit_despatched == 1)
              {
                stats.despatched.count += 1;
              stats.despatched.qty += qty;
              } else {
                
                stats.not_despatched.count += 1;
              stats.not_despatched.qty += qty;
             
              }
            }
            
          } else {
            stats.trim_not_complete.count += 1;
            stats.trim_not_complete.qty += qty;
          }

          
        }

        return stats;
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
          
           
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

